module.exports = __webpack_public_path__ + "img/home-bg-01.0471db06.png";